import { render, staticRenderFns } from "./DarkWebLicenseActions.vue?vue&type=template&id=37c3de74&scoped=true"
import script from "./DarkWebLicenseActions.vue?vue&type=script&lang=js"
export * from "./DarkWebLicenseActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c3de74",
  null
  
)

export default component.exports